import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

export const ProgressBar = styled.div`
  width: 100%;
  height: 5px;
  background-color: ${colorPalette.white[100]};
  border-radius: 5px;
  overflow: hidden;
  flex: 1;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  background-color: ${colorPalette.popOrange[300]};
  width: ${(props) => props.progress}%;
  transition: width 0.3s ease;
  border-radius: 5px;
`;
